/**
 * Glass card — the prototype `.glass` recipe: tinted fill, 40px backdrop blur,
 * the 4-layer inset/drop box-shadow, and the feTurbulence noise-grain `::after`
 * (all carried by the `.tdo-glass` CSS rule). `level={2}` adds the slightly
 * brighter `.tdo-glass-l2` fill. Server-safe.
 */
import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "@/components/ui/cx";

export interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  /** 1 = standard tint, 2 = brighter fill (`.tdo-glass-l2`). Default 1. */
  level?: 1 | 2;
  className?: string;
  children: ReactNode;
}

export function GlassCard({
  level = 1,
  className,
  children,
  ...rest
}: GlassCardProps) {
  return (
    <div
      className={cx("tdo-glass", level === 2 && "tdo-glass-l2", className)}
      {...rest}
    >
      {children}
    </div>
  );
}
